
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/locale/experiences",
      function () {
        return require("private-next-pages/locale/experiences/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/locale/experiences"])
      });
    }
  